export enum EGAlimAppellationEnum {
  AGRICULTURE_BIOLOGIQUE = 'AB',
  EN_CONVERSION = 'CONV',
  LABEL_ROUGE = 'LR',
  APPELLATION_ORIGINE_CONTROLEE = 'AOC',
  APPELLATION_ORIGINE_PROTEGEE = 'AOP',
  INDICATION_GEOGRAPHIQUE_PROTEGEE = 'IGP',
  SPECIALITE_TRADITIONNELLE_GARANTIE = 'STG',
  CERTIFICATION_ENVIRONNEMENTAL_NIVEAU_2 = 'CE2',
  HAUTE_VALEUR_ENVIRONNEMENTALE = 'HVE',
  ECO_PECHE_DURABLE = 'PECHEDURABLE',
  REGIONS_ULTRA_PERIPHERIQUES = 'RUP',
  COMMERCE_EQUITABLE = 'FAIRTRADE',
  FERMIER = 'FERMIER',
  EXTERNALITES_ENVIRONNEMENTAL = 'EXTENV',
  PERFORMANCES_ENVIRONNEMENTALES_APPROVISIONNEMENT_DIRECT = 'PERFENV',
  PROVENANCE_FR = 'FR',
  CIRCUIT_COURT = 'COURT',
  LOCAL = 'LOC',
  REGION_ULTRAPERIPHERIQUE_CANARIS = 'UTCANARIS',
  REGION_ULTRAPERIPHERIQUE_GUADELOUPE = 'UTGUADELOUPE',
  REGION_ULTRAPERIPHERIQUE_GUYANNE = 'UTGUYANNE',
  REGION_ULTRAPERIPHERIQUE_MARTINIQUE = 'UTMARTINIQUE',
  REGION_ULTRAPERIPHERIQUE_REUNION = 'UTREUNION',
}
